

<div  v-if="$route.name === 'publish_portal'">
<button type="button" class="btn bg-transparent btn-sm p-0 me-2" data-bs-toggle="modal" data-bs-target="#subjectsModal" title="Manage topics" aria-label="Manage topics">
  <i class="fa-solid fa-arrows-rotate fs-2"></i>
</button>

</div>
<div v-else>
<button v-if="soulcity_domain" type="button" class="btn bg-transparent btn-sm p-0" data-bs-toggle="modal" data-bs-target="#subjectsModal" title="Manage topics" aria-label="Manage topics">
  <img src="@/assets/images/transfer.png"  class="filter-icon-1" alt="Manage topics">
</button>
<button v-else type="button" class="btn bg-transparent btn-sm" data-bs-toggle="modal" data-bs-target="#subjectsModal" title="Manage topics" aria-label="Manage topics">
  <img src="@/assets/images/refresh.png"  class="filter-icon-2" alt="Manage topics">
</button>
</div>

<teleport to="body">
<div class="modal fade" id="subjectsModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-lg">
    <div class="modal-content rounded-5 shadow scrollable-container">

      <!-- Modal Header -->
      <div class="modal-header bg-primary position-relative">
        <h5 class="modal-title text-white text-xs">Topics & Assign Categories</h5>
        <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2" data-bs-dismiss="modal"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <div v-if="isLoading" class="text-center py-5 w-100">
          <div class="spinner-border text-secondary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p class="mt-2 mb-0 text-muted">Loading Topics...</p>
        </div>

        <div v-else>
          <table v-if="subjects.length" class="table mb-0">
            <tbody>
              <tr v-for="subject in subjects" :key="subject.id" class="border-0">
                <td class="border-0">
                  <div class="d-flex justify-content-between align-items-center mb-2 fw-500">
                    <span class="fw-bold">{{ subject.name || subject_name.name }}</span>

                    <!-- Assign Tags Button -->
                    <button class="btn btn-sm btn-primary"
                            @click="openAssignTags(subject.id)">
                      Assign Categories
                    </button>
                  </div>

                  <!-- Display Existing Tags -->
                <div v-if="Object.keys(groupTagsByCategory(subject.subject_tags)).length > 0"
     class="d-flex flex-wrap align-items-center gap-2">

  <span
    v-for="category in groupTagsByCategory(subject.subject_tags)"
    :key="categories.id"
    class="badge bg-primary text-white rounded-3 d-flex align-items-center px-2 py-1"
  >
    <span>{{ category.name }}</span>
    <span
      class="ms-2 fw-bold"
      style="cursor: pointer;"
      @click="unassignTag(subject.id, category.id)"
    >
      ×
    </span>
  </span>

</div>

<div v-else class="text-muted fst-italic">
  No categories assigned
</div>





                </td>
              </tr>
            </tbody>
          </table>

          <p v-if="!subjects.length" class="text-secondary text-xs text-center">No Topics Available</p>
        </div>
      </div>

    </div>
  </div>
</div>


<div v-for="subject in subjects" :key="'modal-' + subject.id"
     class="modal fade"
     :id="'assignTagsModal-' + subject.id"
     tabindex="-1"
     aria-labelledby="assignTagsLabel"
     aria-hidden="true"
     @show.bs.modal="resetForm">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content rounded-5 shadow scrollable-container">
      <div class="modal-header bg-primary position-relative">
        <h5 class="modal-title text-white text-xs">Assign Categories to {{ subject.name }}</h5>
        <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal" aria-label="Close">
          </button>
      </div>

      <div class="modal-body">

        <!-- Category select -->
        <div class="mb-3">
  <label class="form-label">Select Categories</label>
  <multiselect
    v-model="category_ids"
    :options="categories"
    :multiple="true"
    :close-on-select="false"
    :clear-on-select="false"
    :preserve-search="true"
    placeholder="Choose categories"
    label="name"
    track-by="id"
    class="rounded-5"
  >
  </multiselect>
</div>


      </div>

      <div class="modal-footer">
        <button class="btn btn-sm btn-primary" @click="assignTags(subject.id)">Save</button>
      </div>
    </div>
  </div>
</div>
</teleport>

<!-- Assign Tags Modal (reusable per subject) -->
<!-- Modal -->




<div class="offcanvas offcanvas-start" tabindex="-1" id="portal_members" aria-labelledby="portal_members_label">
  <div class="offcanvas-header">
    <h5 class="offcanvas-title" id="portal_label"></h5>
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
      <h6 class='text-start mx-1 d-flex align-items-center'>Portal Members
        <i
          class="bx bx-plus-circle fs-5 text-primary ms-2 cursor-pointer"
          data-bs-toggle="modal"
        data-bs-target="#add_portal_member_modal"
          title="Add Member" v-if="user_details.user_role=='admin'">
        </i>
        <i
          class="bx bx-trash fs-5 text-danger ms-2 cursor-pointer"
          data-bs-toggle="modal"
        data-bs-target="#delete_portal_member_modal"
          title="Delete Member" v-if="user_details.user_role=='admin'">
        </i>
        </h6>

      <div class="table-container ">
        <table v-if="members.length" class="table mb-0">
          <tbody>
            <tr v-for="member in members" :key="member.id" class="hover-row border-0">
              <td class="border-0">
                <span class="text-decoration-none text-dark">
                  <p class="portal-icon mb-0 d-flex align-items-center">
                    <a class="rounded-circle bg-yellow p-1 shadow-sm color-purple">
                      <i class='bx bx-user fs-5'></i>
                    </a>
                    <span class="text-sm fw-bold mx-3">
                      <a :href="getProfileLink(member)"
                         class="text-decoration-none text-dark">
                        {{ member.first_name }} {{ member.last_name }}
                      </a>
                    </span>
                  </p>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <p v-else class="text-secondary text-xs text-center">
          No Portal members Available
        </p>
      </div>
  </div>
</div>
